export enum PromotionActivityStatus {
  NOT_START,
  STARTED,
  FINISHED
}

// 按钮状态 00-活动未开始 01-待领取 02-已领取 03-无法参数, 04-活动已结束
export enum CouponActivityItemStatusEnums {
  ACTIVITY_NOT_START = "00",
  ACTIVITY_FINISHED = "04",
  WAIT_GET = "01",
  GOT = "02",
  INVALID = "03"
}

export enum CouponActivityTypeEnums {
  DRAW = 0, // 抽奖
  COUPON = 1, // 优惠券
  ITEM_COUPON = 2 // 实物券
}
